import React, { createContext, useMemo, useRef } from 'react';
import posthog from 'posthog-js';

export const HomePageContext = createContext({
  captureSearchStarted: () => {},
});

export const HomePageProvider = ({ children }) => {
  const fillSearchFormStartedAtRef = useRef();

  const contextValue = useMemo(
    () => ({
      captureSearchStarted: (fieldName) => {
        fillSearchFormStartedAtRef.current = new Date();
        posthog.capture('Search Form Started', {
          first_input_field: fieldName,
        });
      },
      captureSearchSubmit: (eventProps) => {
        posthog.capture('Search Form Submitted', {
          ...eventProps,
          fill_form_duration_in_ms: fillSearchFormStartedAtRef.current
            ? new Date() - fillSearchFormStartedAtRef.current
            : undefined,
        });
        fillSearchFormStartedAtRef.current = undefined;
      },
    }),
    []
  );

  return (
    <HomePageContext.Provider value={contextValue}>
      {children}
    </HomePageContext.Provider>
  );
};
